(function () {
  if (window.openBackInStock) return;

  var KLAVIYO_COMPANY_ID = 'QUwBHT';
  var API_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;
  var API_REVISION = '2024-10-15';

  var styles = '' +
    '.bis-modal{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;}' +
    '.bis-modal--open{display:flex;}' +
    '.bis-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,0.6);}' +
    '.bis-modal__dialog{position:relative;background:#fff;max-width:420px;width:calc(100% - 40px);padding:32px 28px;border-radius:4px;box-shadow:0 10px 40px rgba(0,0,0,0.3);}' +
    '.bis-modal__close{position:absolute;top:8px;right:12px;background:none;border:none;font-size:28px;line-height:1;cursor:pointer;color:#000;padding:4px 8px;}' +
    '.bis-modal__title{margin:0 0 8px;font-size:20px;font-weight:800;text-transform:uppercase;}' +
    '.bis-modal__product{margin:0 0 20px;font-size:14px;color:#444;}' +
    '.bis-modal__label{display:block;margin-bottom:6px;font-size:13px;font-weight:600;}' +
    '.bis-modal__input{width:100%;padding:10px 12px;border:1px solid #ccc;border-radius:2px;font-size:15px;margin-bottom:14px;box-sizing:border-box;}' +
    '.bis-modal__input:focus{outline:none;border-color:#000;}' +
    '.bis-modal__submit{width:100%;cursor:pointer;}' +
    '.bis-modal__submit:disabled{opacity:0.6;cursor:wait;}' +
    '.bis-modal__message{margin-top:14px;font-size:14px;text-align:center;}' +
    '.bis-modal__message--success{color:#1a7f3c;}' +
    '.bis-modal__message--error{color:#b40020;}';

  var styleEl = document.createElement('style');
  styleEl.appendChild(document.createTextNode(styles));
  document.head.appendChild(styleEl);

  var modal = null;
  var currentVariantId = null;

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'bis-modal';
    modal.innerHTML =
      '<div class="bis-modal__backdrop" data-bis-close></div>' +
      '<div class="bis-modal__dialog" role="dialog" aria-labelledby="bis-modal-title" aria-modal="true">' +
        '<button type="button" class="bis-modal__close" data-bis-close aria-label="Close">&times;</button>' +
        '<h2 id="bis-modal-title" class="bis-modal__title">Notify me when available</h2>' +
        '<p class="bis-modal__product"></p>' +
        '<form class="bis-modal__form">' +
          '<label for="bis-modal-email" class="bis-modal__label">Email address</label>' +
          '<input type="email" id="bis-modal-email" class="bis-modal__input" required placeholder="you@example.com" autocomplete="email">' +
          '<button type="submit" class="btn btn-black bis-modal__submit">Notify me</button>' +
        '</form>' +
        '<div class="bis-modal__message" role="status" aria-live="polite"></div>' +
      '</div>';
    document.body.appendChild(modal);

    var closers = modal.querySelectorAll('[data-bis-close]');
    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', closeModal);
    }
    modal.querySelector('.bis-modal__form').addEventListener('submit', handleSubmit);
    return modal;
  }

  function openModal(data) {
    buildModal();
    currentVariantId = data && data.variantId;
    if (!currentVariantId) {
      console.error('back-in-stock: no variantId provided', data);
      return;
    }
    modal.querySelector('.bis-modal__product').textContent = (data.productName || '');
    var form = modal.querySelector('.bis-modal__form');
    form.style.display = '';
    var msg = modal.querySelector('.bis-modal__message');
    msg.textContent = '';
    msg.className = 'bis-modal__message';
    var emailInput = modal.querySelector('#bis-modal-email');
    emailInput.value = '';
    var submitBtn = modal.querySelector('.bis-modal__submit');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Notify me';
    modal.classList.add('bis-modal--open');
    setTimeout(function () { emailInput.focus(); }, 50);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('bis-modal--open');
  }

  function handleSubmit(e) {
    e.preventDefault();
    var emailInput = modal.querySelector('#bis-modal-email');
    var submitBtn = modal.querySelector('.bis-modal__submit');
    var messageEl = modal.querySelector('.bis-modal__message');
    var email = (emailInput.value || '').trim();
    if (!email || !currentVariantId) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';
    messageEl.textContent = '';
    messageEl.className = 'bis-modal__message';

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + currentVariantId
            }
          }
        }
      }
    };

    fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': API_REVISION
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.status === 202 || response.ok) {
          modal.querySelector('.bis-modal__form').style.display = 'none';
          messageEl.textContent = "Thanks! We'll email you when this is back in stock.";
          messageEl.className = 'bis-modal__message bis-modal__message--success';
        } else {
          return response.text().then(function (txt) {
            console.error('Klaviyo BIS error', response.status, txt);
            messageEl.textContent = 'Something went wrong. Please try again.';
            messageEl.className = 'bis-modal__message bis-modal__message--error';
            submitBtn.disabled = false;
            submitBtn.textContent = 'Notify me';
          });
        }
      })
      .catch(function (err) {
        console.error('Klaviyo BIS request failed', err);
        messageEl.textContent = 'Something went wrong. Please try again.';
        messageEl.className = 'bis-modal__message bis-modal__message--error';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify me';
      });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('bis-modal--open')) {
      closeModal();
    }
  });

  window.openBackInStock = openModal;
})();